import { useEffect } from "react";
import CircleIconAnimationButton from "../../components/ui/circle-icon-animation-button";

const GetStartedSection = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      throw new Error("Sentry Delayed Production Error Test");
    }, 10000);

    return () => clearTimeout(timer);
  }, []);
  return (
    <div className="relative w-full rounded-4xl bg-[#111212] py-20 px-2.5 md:px-6 overflow-hidden">
      {/* ... existing SVG noise ... */}
      <div className="absolute inset-0 opacity-[0.06] pointer-events-none">
        <svg
          className="w-full h-full"
          viewBox="0 0 100 100"
          preserveAspectRatio="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <filter id="noiseFilter">
            <feTurbulence
              type="fractalNoise"
              baseFrequency="0.8"
              numOctaves="4"
              stitchTiles="stitch"
            />
          </filter>
          <rect width="100%" height="100%" filter="url(#noiseFilter)" />
        </svg>
      </div>

      <div className="relative max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
        <div className="w-full flex justify-center">
          <div className="overflow-hidden rounded-xl shadow-2xl">
            <img
              src="https://cdn.shopify.com/s/files/1/0771/9691/9043/files/edmonton-sign-company-metal-fx-bucket-truck.jpg?v=1773202624"
              alt="Sign Installation"
              className="w-full h-105 md:h-125 object-cover hover:scale-105 transition duration-700"
            />
          </div>
        </div>

        <div className="flex flex-col gap-8 max-w-xl">
          <h1 className="text-3xl md:text-5xl font-semibold text-white leading-tight">
            <span className="text-[#4c94ba]">Sign Service</span> & Installation
          </h1>

          <p className="text-gray-300 text-lg leading-relaxed">
            No matter what your signage installation needs are, our experienced
            team has the knowledge, tools, and equipment to deliver reliable
            solutions for businesses of every size.
          </p>

          <p className="text-gray-400 text-base">
            We provide quick turnarounds, dependable maintenance, and
            cost-effective services to ensure your signage performs at its best.
          </p>

          <div className="w-fit">
            <CircleIconAnimationButton>Get Started</CircleIconAnimationButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetStartedSection;
